if (!customElements.get('faqs-element')) {
  class FaqsElement extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.faq-item__question');
        if (!button || !this.contains(button)) return;

        const expanded = button.getAttribute('aria-expanded') === 'true';
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        const faq = button.closest('.faq-item');

        this.querySelectorAll('.faq-item').forEach((arrayFaq) => {
          if (arrayFaq !== faq) {
            const arrayButton = arrayFaq.querySelector('.faq-item__question');
            const arrayPanel = document.getElementById(arrayButton.getAttribute('aria-controls'));
            arrayFaq.classList.remove('active');
            arrayButton.setAttribute('aria-expanded', 'false');
            arrayPanel.setAttribute('aria-hidden', 'true');
            arrayPanel.style.height = arrayPanel.scrollHeight + 'px';
            requestAnimationFrame(() => (arrayPanel.style.height = '0px'));
          }
        });

        if (!expanded) {
          faq.classList.add('active');
          button.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function handler() {
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', handler);
          });
        } else {
          faq.classList.remove('active');
          button.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(() => (panel.style.height = '0px'));
        }
      });
    }
  }

  customElements.define('faqs-element', FaqsElement);
}